// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1jJ1x","detailsBorder":"styles_detailsBorder__wf9Kw"};